module.exports = ".col-md-4, .col-md-2, .col-md-3 {\n    padding-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario/usuario-novo/usuario-novo.component.css
// module id = ./src/app/usuario/usuario-novo/usuario-novo.component.css
// module chunks = main